module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_8019.ff97f8dd.png";